import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/oneshubh/satyam/SocialGraphs/src/app/(public-pages)/profile/[username]/HeaderProfile.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/oneshubh/satyam/SocialGraphs/src/components/BottomNav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/oneshubh/satyam/SocialGraphs/src/components/LeftSidebar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/oneshubh/satyam/SocialGraphs/src/components/RightSidebar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/oneshubh/satyam/SocialGraphs/src/components/TopNav.tsx");
